import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../../navigation/paths";
import { useAuthUser } from "./useAuthUser";

export const useAuth = () => {
  const { user, checkedAuth } = useAuthUser();
  const navigate = useNavigate();
  const navRef = useRef(navigate);

  useEffect(() => {
    if (!checkedAuth) return;
    if (!user) navRef.current(paths.auth.login);
  }, [checkedAuth, navRef, user]);

  // returning these shouldn't really be this hooks job but to prevent
  // needing to call useAuthUser again when its already use in here
  return { user, checkedAuth };
};
